import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import Box, { BoxProps as MuiBoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import Helmet from '../../components/Helmet';
import { Questionnaire as ClassityQuestionnaire } from '@classity-edtech/ui-questionnaire';
import { parseToken, windowExists } from '@classity-edtech/ui-base';
import { useResetResponseCacheMutation } from '../../services/response';
import { webPaths } from '../../routes/paths';
import { useGetQuestionnaireQuery } from '../../services/questionnaire';
import { FreeFormName } from '@classity-edtech/platform-utils';
import { CircularProgress } from '@mui/material';
import { Roles } from '../../utils/enum';

export interface HomeProps extends MuiBoxProps {}

export const VerifyEmail = ({ className }: HomeProps) => {
  const navigate = useNavigate();
  const [resetResponse] = useResetResponseCacheMutation();
  const getFreeformKey = (name: string) => {
    return Object.keys(FreeFormName).find(key => FreeFormName[key] === name);
  };

  const token = windowExists && parseToken((windowExists?.localStorage as any)?.getItem('token'));

  const { data: form, isLoading: loadingForm } = useGetQuestionnaireQuery({
    name: getFreeformKey(FreeFormName.REGISTRATIONS_STUDENT),
  });

  const authAction = async (role: string, user: string, token: string) => {};

  const getUserRole = (role: string) => {
    switch (role) {
      case Roles.PARENT:
        return 'parent';
      case Roles.STUDENT:
        return 'student';

      default:
        return '';
    }
  };

  const emailVerificationAction = async () => {
    resetResponse({ userId: token.user });
    localStorage.removeItem('lastQuestionnaire');
    localStorage.removeItem('responses');
    localStorage.removeItem('userFlow');

    (windowExists?.dataLayer as any)?.push({
      event: 'verify_email',
      traffic_type: process.env.NODE_ENV === 'production' ? 'production' : 'local',
      user_id: token.uid,
      role: getUserRole(token.role),
      registered: !!token,
    });

    navigate(`/${webPaths.emailConfirmation}`);
  };

  const handleSubmitResponse = async () => {};

  return (
    <>
      <Helmet title='Classity: Nurturing the next generation of science and tech leaders' />
      {loadingForm ? (
        <Box className={`${className} questionnaire__loader`}>
          <CircularProgress />
        </Box>
      ) : (
        <></>
      )}
    </>
  );
};

VerifyEmail.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

VerifyEmail.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(VerifyEmail)(
  ({ theme }) => `
`,
);
